import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Polyglot from 'node-polyglot';
import { getLocale, getPhrases } from '../redux/selectors';

var useTranslate = function useTranslate(prefix) {
  var locale = useSelector(getLocale);
  var phrases = useSelector(getPhrases);
  var translate = useMemo(function () {
    var p = new Polyglot({
      phrases: phrases[locale] || phrases.default || {}
    });
    return function (key) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return p.t.apply(p, [key].concat(args));
    };
  }, [phrases, locale]);
  var t = useMemo(function () {
    return function (key) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return translate.apply(void 0, [[prefix, key].filter(function (s) {
        return s;
      }).join('.')].concat(args));
    };
  }, [prefix, translate]);
  return t;
};

export default useTranslate;